export const safeInit = (fn, name) => {
	try {
		fn();
		console.log(`[INIT OK]: ${name}`);
	} catch (e) {
		console.error(`[INIT FAIL]: ${name}`, e);
	}
};